import { produce } from 'immer'
import { find, forEach, map, remove } from 'lodash'
import { WorkOrderData } from '../apis/workOrder.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  find (workOrders: WorkOrderData[], id: number) {
    return find(workOrders, { id })
  },

  searchOptions (workOrders: WorkOrderData[]) {
    return map(workOrders, workOrder => {
      const { code, id } = workOrder
      return { id, value: code }
    })
  },

  tableHorizontalData (
    workOrders: WorkOrderData[]
  ): TableHorizontalData<WorkOrderData>[] {
    forEach(workOrders, (workOrder: TableHorizontalData<WorkOrderData>) => {
      const actions: ActionName[] = ['view', 'edit', 'delete']
      workOrder.actions = actions
    })
    return workOrders
  },

  delete (workOrders: TableHorizontalData<WorkOrderData>[], id: number) {
    return produce(workOrders, workOrders => {
      remove(workOrders, { id })
    })
  }
}
